export const getLanguage = configLanguages => {
  // INFO: get browser language
  // const fullBrowserLanguage =
  //   window.navigator.userLanguage || window.navigator.language;
  // const browserLanguage = fullBrowserLanguage.indexOf('-')
  //   ? fullBrowserLanguage.split('-')[0]
  //   : fullBrowserLanguage;

  // INFO: set user language according their browser language and according chosen language (that was stored to local storage)
  // let userLanguage = (browserLanguage === 'ru' || browserLanguage === 'uk' || browserLanguage === 'be') ? 'ru' : 'en';
  let userLanguage = 'en';

  if (localStorage.getItem('userLanguage') !== null) {
    userLanguage = localStorage.getItem('userLanguage');
  }

  // INFO: get default language from config
  const defaultLanguage = configLanguages.find(item => item.isDefault).value;

  // INFO: check whether config file has browser language
  const condition = configLanguages.find(item => item.value === userLanguage);

  if (condition) {
    return userLanguage;
  }

  return defaultLanguage;
};



// WEBPACK FOOTER //
// ./src/store/modules/utils/languageHelpers.js